// ============================================================================
// Zero-Allocation Object & ArrayBuffer Pool for 60 FPS Stream Decoding
// ============================================================================

export interface DecodedNxkvPacket {
  frameType: number;
  seq: number;
  payloadText: string;
  reset(): void;
}

class PooledPacket implements DecodedNxkvPacket {
  public frameType = 0;
  public seq = 0;
  public payloadText = '';

  public reset(): void {
    this.frameType = 0;
    this.seq = 0;
    this.payloadText = '';
  }
}

export class NxkvPacketPool {
  private readonly pool: PooledPacket[] = [];
  private readonly maxPoolSize: number;

  constructor(initialSize = 32, maxPoolSize = 128) {
    this.maxPoolSize = maxPoolSize;
    for (let i = 0; i < initialSize; i++) {
      this.pool.push(new PooledPacket());
    }
  }

  public acquire(frameType: number, seq: number, payloadText: string): DecodedNxkvPacket {
    const pkt = this.pool.pop() || new PooledPacket();
    pkt.frameType = frameType;
    pkt.seq = seq;
    pkt.payloadText = payloadText;
    return pkt;
  }

  public release(pkt: DecodedNxkvPacket): void {
    pkt.reset();
    if (this.pool.length < this.maxPoolSize) {
      this.pool.push(pkt as PooledPacket);
    }
  }
}

export class ByteBufferPool {
  private readonly buckets: Map<number, Uint8Array[]> = new Map();

  public acquire(minLength: number): Uint8Array {
    const bucketSize = 1 << Math.ceil(Math.log2(Math.max(1024, minLength)));
    const list = this.buckets.get(bucketSize);
    if (list && list.length > 0) {
      return list.pop()!;
    }
    return new Uint8Array(bucketSize);
  }

  public release(buf: Uint8Array): void {
    const size = buf.byteLength;
    let list = this.buckets.get(size);
    if (!list) {
      list = [];
      this.buckets.set(size, list);
    }
    if (list.length < 24) {
      list.push(buf);
    }
  }
}
